// extracted by mini-css-extract-plugin
export default {"header":"Form_header__P51t-","newDoc_group":"Form_newDoc_group__f2o0I","newDoc_checkbox":"Form_newDoc_checkbox__eNlQR","newDoc_label":"Form_newDoc_label__Hrw4f"};